import { render, staticRenderFns } from "./ChatPrivateVideo.vue?vue&type=template&id=6e1aba7a&scoped=true"
import script from "./ChatPrivateVideo.vue?vue&type=script&lang=js"
export * from "./ChatPrivateVideo.vue?vue&type=script&lang=js"
import style0 from "./ChatPrivateVideo.vue?vue&type=style&index=0&id=6e1aba7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1aba7a",
  null
  
)

export default component.exports